import CrudRepository from './CrudRepository'
export default class SocialResponsibilityNewsRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/socialResponsibility/web/top')
  }
}
